export default __webpack_public_path__ + "static/media/6102.4bd2e581.svg";